{# src/Resources/app/administration/src/module/sw-cms/elements/product-finder/config/sw-cms-el-config-product-finder.html.twig #}
<div class="sw-cms-el-config-product-finder">
    <sw-container columns="1fr" gap="20px">
        
        <!-- Product Finder Selection -->
        <div class="sw-cms-el-config-product-finder__selection">
            <sw-entity-single-select
                v-model:value="element.config.productFinder.value"
                entity="xps_product_finder"
                :criteria="productFinderCriteria"
                :label="$tc('sw-cms.elements.productFinder.config.label')"
                :placeholder="$tc('sw-cms.elements.productFinder.config.placeholder')"
                label-property="name"
                value-property="id"
                @update:value="onProductFinderChange">
            </sw-entity-single-select>
        </div>

        

        <!-- Help Text -->
        <mt-banner variant="info">
            {{ $tc('sw-cms.elements.productFinder.config.helpText') }}
        </mt-banner>

    </sw-container>
</div>